import store from '@/store'

const mixin = {
  computed: {
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    isAccountPaid () {
      return this.$store.getters.isAccountPaid
    },
    accountAccess () {
      return this.$store.getters.accountAccess
    },
    accountPreferences () {
      return this.$store.getters.accountPreferences
    }
  },
  methods: {
    async refreshPaidStatus () {
      await store.dispatch('queryIdTokenClaims')
    },
    async queryAccountAlerts () {
      await store.dispatch('queryAccountAlerts')
    }
  }
}

export default mixin
